import React from "react";
import type {VoidFunctionComponent} from "react";
import {useSongDetailsEmptyLessonResultsMessageLogic} from "./SongDetailsEmptyLessonResultsMessage.logic";
import {EmptyViewMessage} from "../../../../../../components/common/empty-view-message/EmptyViewMessage";

export interface ISongDetailsEmptyLessonResultsMessageProps {
}

export const SongDetailsEmptyLessonResultsMessage: VoidFunctionComponent<ISongDetailsEmptyLessonResultsMessageProps> = ({}) => {
  const {navigateToSongsPageOnClick} = useSongDetailsEmptyLessonResultsMessageLogic();
  return (
    <EmptyViewMessage
      icon={"icon-songs"}
      message={"No arrangements available"}
      buttonText={"Browse Songs"}
      buttonClickHandler={navigateToSongsPageOnClick}
    />
  );
}
